import { useMemo } from "react";
import './Participacion.css'

const Participaciones = ({data})=>{
    const { premio, arryPuestos } = data.sorteo
    const obtenerNumerosComprados = (puestos) => 
        puestos
            .filter(puesto => Object.values(puesto)[0] === data.uid)
            .map(puesto => Object.keys(puesto)[0]);

    const numerosComprados = useMemo(() => obtenerNumerosComprados(arryPuestos), [arryPuestos, data.uid]);

    return(
        <tr className="participacion-row">
            <td className="premio-cell">{data.sorteo.typeLot === 'Express' ? 'Acumulado $' + data.sorteo.premioBase.toLocaleString('es-ES') : premio}</td>
            <td className="numeros-cell">{numerosComprados.length > 0 ? numerosComprados.join(', ') : 'Sin jugar'}</td>
            <td className={numerosComprados.length > 0 ? 'estado-cell-'+data.sorteo.estado:'estado-cell-sinJugar'}>{numerosComprados.length > 0 ? data.sorteo.estado : 'Sin jugar'}</td>
        </tr>
    )
}
export default Participaciones